module.exports = __webpack_public_path__ + "img/5.7744af1f.svg";